import axios from '../../utils/axios';

export const checkForAffected = (params: { [key: string]: object | string }) =>
    axios.post('v1/check-affected-bundles', params);
